import {gettext} from 'topmeteo/utils/i18n';

const Label = gettext('Total');

const getTotal = ({formatCurrency, packet, options, discount}) => {
    let total = 0;

    if (packet) total += packet.price;
    if (options && options.length) total += options.reduce((total, {price}) => total + price, 0);
    if (discount) total -= discount;

    return formatCurrency(total);
};

const Total = props => (
    <tr className="total">
        <td>{Label}</td>
        <td className="price">
            {getTotal(props)}
        </td>
    </tr>
);

export default Total;
